var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80319 0V14L3.52128 9.33333H0V4.66667H3.52128L8.80319 0ZM7.24541 10.5424V3.45668L4.11107 6.22654L1.55859 6.22624V7.77286L4.11107 7.77345L7.24541 10.5424ZM12.6427 12.0771C14.5125 8.86131 14.4521 4.78847 12.454 1.63547L11.1387 2.47122L11.2785 2.70008C12.864 5.39161 12.829 8.82238 11.1783 11.4891L12.5024 12.3109L12.6427 12.0771Z",
    fill: "#338FCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.4dace3ee7f8272d1bd2aff5be6fa3a76.svg";
export { ForwardRef as ReactComponent };